import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";

export default function Compliance() {
  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>Corporate Compliance Statement</h1>


      </div>

      {/* TERMS SECTION */}
      <Container style={{ padding: "70px 10px" }}>
        <Row>
          <Col lg={12}>
            <h3 className="mb-3">1. Our Commitment</h3>
            <p>
              KVL Matrimony a Platform https://kvlmatrimony.com, is committed to operating a secure, transparent and legally compliant matrimonial platform while safeguarding the interests of its members and stakeholders.
            </p>
            <h3 className="mt-5 mb-3">2. Regulatory Compliance</h3>
            <p>
              The Platform endeavours to comply with all applicable laws and regulations, including:<br />
              •	Digital Personal Data Protection Act, 2023<br />
              •	Information Technology Act, 2000<br />
              •	Applicable Rules, Notifications and Guidelines<br />
              •	Consumer Protection Act, 2019<br />
              •	Applicable Taxation and Financial Laws
            </p>
            <h3 className="mt-5 mb-3">3. Information Security</h3>
            <p>KVL Matrimony implements reasonable administrative, technical and organizational measures to protect Platform infrastructure and personal information against unauthorized access, alteration, disclosure, misuse or loss.<br />
              Security practices are reviewed periodically and enhanced as required.

            </p>

            <h3 className="mt-5 mb-3">4. Data Governance</h3>
            <p>
              Personal information is collected, processed, retained and disposed of in accordance with the Privacy, Data Processing & DPDP Compliance Policy and applicable legal requirements.
            </p>

            <h3 className="mt-5 mb-3">5. Third-Party Service Providers</h3>
            <p>
              The Platform may engage trusted third-party service providers for hosting, payment processing, communications, analytics, security and related technology services.<br />
              Such providers are expected to maintain appropriate security and confidentiality standards.
            </p>

            <h3 className="mt-5 mb-3">6. Incident Management</h3>
            <p>
              Security incidents and operational disruptions are assessed promptly, appropriate corrective measures are undertaken and notifications are issued where required under applicable law.
            </p>

            <h3 className="mt-5 mb-3">7. Intellectual Property</h3>
            <p>
              All intellectual property associated with KVL Matrimony, including its name, logo, software, content, databases, design and related materials, is owned by or licensed to the Platform and is protected under applicable intellectual property laws.<br />
              Unauthorized use, reproduction or distribution is prohibited.

            </p>

            <h3 className="mt-5 mb-3">8. Grievance Redressal</h3>
            <p>KVL Matrimony maintains a grievance mechanism for users to submit complaints, concerns or requests relating to the Platform or its services.<br />
              Grievances shall be acknowledged and addressed within reasonable timelines in accordance with applicable law.

            </p>
            <h3 className="mt-5 mb-3">9. Business Continuity</h3>
            <p>
              Reasonable measures are maintained to support the continuity, availability and recovery of essential Platform services in the event of operational disruptions.

            </p>

            <h3 className="mt-5 mb-3">10. Policy Review</h3>
            <p>
              Compliance practices and related policies are reviewed periodically to align with changes in technology, business operations and applicable legal requirements.
            </p>

            <h3 className="mt-5 mb-3">11. Contact</h3>
            <p>
              Questions relating to compliance, legal matters, data protection or grievance redressal may be addressed through the official contact details published on the Website.
            </p>

            <h3 className="mt-5 mb-3">12. Corporate Statement</h3>
            <p>
              KVL Matrimony is committed to conducting its operations responsibly, ethically and in compliance with applicable laws while continually enhancing user trust, information security and service quality.
            </p>





            <p className="mt-5 text-muted">
              <strong>Last Updated:</strong>5th, July 2026
            </p>
          </Col>
        </Row>
      </Container>





      <Footer />
    </>
  );
}
